import { cn } from '@/lib/utils';
import { navItemStyles } from './styles';
import { DetailedHTMLProps, AnchorHTMLAttributes, ReactNode } from 'react';

export function NavItemExternalLink({
  className,
  children,
  ...props
}: DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & { children: ReactNode }) {
  return (
    <a
      className={cn(navItemStyles(), 'flex items-center gap-2', className)}
      {...props}>
      {children}
    </a>
  );
}
